import React from 'react';
import { useTranslation } from 'react-i18next';

const AddGradeModal: React.FC = () => {
  const { t } = useTranslation();

  React.useEffect(() => {
    console.warn('Placeholder: AddGradeModal is not implemented yet.');
  }, []);

  return null;
};

export default AddGradeModal;
